/*eslint-disable*/

export default function enquireNow() {
  getStoreLocations();

  const enquireNowButton = document.getElementById("enquireNow");
  const enquireNowForm = document.querySelector(".enquire-form-container");
  const enquireNowCloseButton = document.querySelector(".close-button");
  const variantInput = document.querySelector(
    ".enquire-form-container .enquire-product"
  );
  const variantInputField = document.querySelector(
    '.enquire-form-container input[name="contact[product_variant]"]'
  );
  const formSubmitButton = document.querySelector(".submit-button");

  let isVariantChanged = false;

  if (!enquireNowButton || !enquireNowForm || !enquireNowCloseButton) return;

  const openModal = () => {
    enquireNowForm.style.display = "flex";
    if (isVariantChanged) {
      const currentVariant = enquireNowForm.getAttribute(
        "data-current-variant"
      );
      if (variantInput) {
        variantInput.innerHTML = currentVariant;
        variantInputField.value = currentVariant;
      }
    }
    window.addEventListener("click", handleOutsideClick);
  };

  const closeModal = () => {
    enquireNowForm.style.display = "none";
    window.removeEventListener("click", handleOutsideClick);
  };

  const handleOutsideClick = (event) => {
    if (event.target === enquireNowForm) {
      closeModal();
    }
  };

  document.addEventListener("variant:changed", (event) => {
    isVariantChanged = true;
    const currentVariant = event.detail.variant.title;
    enquireNowForm.setAttribute("data-current-variant", currentVariant);
  });

    // formSubmitButton.addEventListener("click", (event) => {
    // event.preventDefault();
    // });



  enquireNowButton.addEventListener("click", openModal);
  enquireNowCloseButton.addEventListener("click", closeModal);
}

async function getStoreLocations() {
  try {
    const query = `query {
    locations(first: 50) {
        edges {
        node {
            name
        }
        }
    }
    }`;
    const response = await fetch("/api/2025-04/graphql.json", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Shopify-Storefront-Access-Token": storefrontAccessToken,
      },
      body: JSON.stringify({ query }),
    });

    const data = await response.json();
    const locations = data.data.locations.edges.map((edge) => {
        return edge.node.name;

    })

    const selectLocations = document.getElementById("storeLocation");
    if (selectLocations) {
      locations.forEach((location) => {
        const option = document.createElement("option");
        option.value = location;
        option.textContent = location;
        selectLocations.appendChild(option);
      });
    }

  } catch (error) {
    console.error("Error fetching store locations:", error);
  }
}
